import { createReducer, on } from '@ngrx/store';
import { SelfServiceableAccounts, SelfServiceableAccountsPayload } from '../models/accounts.model';
import {
  loadAccounts,
  loadAccountsSuccess,
  loadAccountsError,
  updateAccountsWithCasData,
  clearAccounts,
} from './accounts.action';

export interface AccountsState {
  loading: boolean;
  loaded: boolean;
  accounts: SelfServiceableAccounts;
  gatewayError?: string;
  loanError?: string;
  creditCardError?: string;
  bechError?: string;
}

export const initialState: AccountsState = {
  loading: false,
  loaded: false,
  accounts: undefined,
  gatewayError: undefined,
  loanError: undefined,
  creditCardError: undefined,
  bechError: undefined,
};

export const accountsReducer = createReducer(
  initialState,

  on(loadAccounts, (state) => ({
    ...state,
    loaded: false,
    loading: true,
  })),

  on(loadAccountsSuccess, (state, action) => {
    const [loanError, cardError, bechError] = getErrorsFromPayload(action.data);
    return {
      ...state,
      gatewayError: null,
      loanError: loanError,
      creditCardError: cardError,
      bechError: bechError,
      accounts: action.data,
    };
  }),

  on(loadAccountsError, (state, action) => ({
    ...state,
    gatewayError: action.error,
    loading: false,
    loaded: false,
  })),

  // Note: don't mark accounts as done loading until accounts
  // get updated with CAS data (loan and card)
  on(updateAccountsWithCasData, (state, action) => {
    const updatedAccounts = action.data;
    return {
      ...state,
      loading: false,
      loaded: true,
      accounts: {
        ...updatedAccounts,
      },
    };
  }),

  on(clearAccounts, (state, action) => ({ ...initialState }))
);

const getErrorsFromPayload = (payload: SelfServiceableAccountsPayload) => {
  const loanError = (payload.errors && payload.errors.loan) || null;
  const cardError = (payload.errors && payload.errors.card) || null;
  const bechError = (payload.errors && payload.errors.bech) || null;
  return [loanError, cardError, bechError];
};
